import { animate, inView, stagger, timeline } from "motion";

const animateSvgBorder = (el) => {
  el.style.width = 0;
  el.style.height = "2px";
  el.style.opacity = 1;

  timeline([
    [el, { width: "100%" }, { duration: 0.6, easing: "linear" }],
    [el, { height: "100%" }, { duration: 0.3, easing: "linear" }],
  ]);
};

const variants = {
  "fade-up": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-up-left": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-down": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-left": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-left-slow": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-right": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-in": {
    opacity: 1,
  },
  "scale-in": {
    opacity: 1,
    transform: "scale(1)",
  },
};

const reveal = (group) => {
  if (group.dataset.srGroup === "sequence") {
    const sequence = [];

    group.querySelectorAll(`[data-sr]`).forEach((el) => {
      const variant = variants[el.dataset.sr];

      if (variant && el.style.display !== "none") {
        sequence.push([el, variant, { ease: "ease", duration: 0.8, at: "-0.4" }]);
      }
    });

    inView(
      group,
      () => {
        timeline(sequence).finished.then((animations) => {
          animations?.forEach((animation) => {
            animation.effect?.target?.setAttribute("data-sr-done", true);
          });
        });
      },
      {
        margin: "0px 0px -25% 0px",
      },
    );
  } else {
    for (const [key, opts] of Object.entries(variants)) {
      const els = Array.from(group.querySelectorAll(`[data-sr="${key}"]`));

      let duration = 0.8;

      if (key === "fade-in" || key === "fade-left-slow") {
        duration = 1.5;
      }

      if (els.length) {
        els.forEach((el, index) => {
          const checklists = el.querySelectorAll(".as-check-list-blue");

          if (checklists.length) {
            let children = [];

            Array.from(el.children).forEach((child) => {
              if (child.classList.contains("as-check-list-blue")) {
                const lis = Array.from(child.querySelectorAll("li"));

                children = [...children, ...lis];
              } else {
                children.push(child);
              }
            });

            children.map((child) => child.setAttribute("data-sr", "fade-up"));

            el.removeAttribute("data-sr");
            els.splice(index, 1, ...children);
          }
        });

        inView(
          group,
          () => {
            animate(els, opts, {
              duration,
              delay: stagger(0.2),
            }).finished.then((animations) => {
              animations?.forEach((animation) => {
                animation.effect?.target?.setAttribute("data-sr-done", true);
              });
            });
          },
          {
            margin: "0px 0px -25% 0px",
          },
        );
      }
    }
  }
};

const handleMutations = (group, mutationList) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      reveal(group);
    }
  }
};

export default {
  init: () => {
    document.querySelectorAll(".angled-border").forEach((el) => {
      const observer = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting) {
            setTimeout(() => {
              animateSvgBorder(el);
            }, 250);

            observer.disconnect();
          }
        },
        {
          threshold: [1],
        },
      );

      observer.observe(el);
    });

    document.querySelectorAll("[data-sr-group]").forEach((group) => {
      if (group.closest("[data-disable-animations]")) {
        group.removeAttribute("data-sr-group");
        return;
      }

      if (group.dataset.srGroup !== "trigger") {
        reveal(group);
      }

      if (group.dataset.srGroup === "observe") {
        const observer = new MutationObserver(handleMutations.bind(null, group));

        observer.observe(group, {
          childList: true,
          subtree: true,
        });
      }
    });
  },
  reveal,
};
